module.exports = __webpack_public_path__ + "img/meme_28.c5331bf2.jpg";